module.exports = __webpack_public_path__ + "static/media/kor_1.cb99ed5a.jpg";